/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {RJSFSchemas} from './RJSFSchemas';
import {RJSFSchemasFromJSON, RJSFSchemasFromJSONTyped, RJSFSchemasToJSON} from './RJSFSchemas';
import type {WorkZone} from './WorkZone';
import {WorkZoneFromJSON, WorkZoneFromJSONTyped, WorkZoneToJSON} from './WorkZone';

/**
 *
 * @export
 * @interface AppProjectsTechprocessSchemasUpdateOut
 */
export interface AppProjectsTechprocessSchemasUpdateOut {
  /**
   *
   * @type {boolean}
   * @memberof AppProjectsTechprocessSchemasUpdateOut
   */
  treeChanged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AppProjectsTechprocessSchemasUpdateOut
   */
  dataChanged: boolean;
  /**
   *
   * @type {{ [key: string]: RJSFSchemas; }}
   * @memberof AppProjectsTechprocessSchemasUpdateOut
   */
  schemas: {[key: string]: RJSFSchemas} | null;
  /**
   *
   * @type {string}
   * @memberof AppProjectsTechprocessSchemasUpdateOut
   */
  name: string | null;
  /**
   *
   * @type {WorkZone}
   * @memberof AppProjectsTechprocessSchemasUpdateOut
   */
  workzone: WorkZone | null;
}

/**
 * Check if a given object implements the AppProjectsTechprocessSchemasUpdateOut interface.
 */
export function instanceOfAppProjectsTechprocessSchemasUpdateOut(
  value: object
): value is AppProjectsTechprocessSchemasUpdateOut {
  if (!('dataChanged' in value) || value['dataChanged'] === undefined) return false;
  if (!('schemas' in value) || value['schemas'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('workzone' in value) || value['workzone'] === undefined) return false;
  return true;
}

export function AppProjectsTechprocessSchemasUpdateOutFromJSON(
  json: any
): AppProjectsTechprocessSchemasUpdateOut {
  return AppProjectsTechprocessSchemasUpdateOutFromJSONTyped(json, false);
}

export function AppProjectsTechprocessSchemasUpdateOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AppProjectsTechprocessSchemasUpdateOut {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    dataChanged: json['data_changed'],
    schemas: json['schemas'] == null ? null : mapValues(json['schemas'], RJSFSchemasFromJSON),
    name: json['name'],
    workzone: WorkZoneFromJSON(json['workzone'])
  };
}

export function AppProjectsTechprocessSchemasUpdateOutToJSON(
  value?: AppProjectsTechprocessSchemasUpdateOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    data_changed: value['dataChanged'],
    schemas: value['schemas'] == null ? null : mapValues(value['schemas'], RJSFSchemasToJSON),
    name: value['name'],
    workzone: WorkZoneToJSON(value['workzone'])
  };
}
